/* ========================================================================
 * Website: slider.js v0.0.1
 * ======================================================================== */

;+(function($) {
  "use strict"
  // SLIDER CLASS DEFINITION
  // =========================

  var toggle = '[data-toggle="fullscreen"]'
  var Slider = function(element, options) {
    this.$element = $(element)
    this.options = this.getOptions(options)

    this.init()

  }

  Slider.VERSION = "0.0.1"

  Slider.DEFAULTS = {
    autoplay: true,
    autoplaySpeed: 4000,
    // appendDots: $('#carousel-dots'),
    pauseOnHover: true,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 800,
    fade: false,
    cssEase: 'cubic-bezier(0.19,1,.22,1)',
    adaptiveHeight: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          dots: true,
          // arrows: true,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          dots: true,
          // arrows: true,
        }
      },
    ]
  }

  Slider.prototype.init = function() {

    var options = this.options
    this.$element.slick(options);

  }

  Slider.prototype.getDefaults = function() {
    return Slider.DEFAULTS
  }

  Slider.prototype.getOptions = function(options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
    return options
  }

  // SLIDER PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function() {
      var $this = $(this)
      var data = $this.data("gf.slider")
      var options = $.extend(
        {},
        Slider.DEFAULTS,
        $this.data(),
        typeof option == "object" && option
      )
      var options = typeof option == "object" && option

      if (!data) $this.data("gf.slider", (data = new Slider(this, options)))
    })
  }

  var old = $.fn.slider

  $.fn.slider = Plugin
  $.fn.slider.Constructor = Slider

  // SLIDER NO CONFLICT
  // =================

  $.fn.slider.noConflict = function() {
    $.fn.slider = old
    return this
  }

  // SLIDER DATA-API
  // ==============

  $(window).on("load", function() {
    $(".slider").each(function() {
      var $slider = $(this)
      Plugin.call($slider, $slider.data())
    })
  })
})(jQuery)
